<ngx-ui-loader [hasProgressBar]="false"></ngx-ui-loader>
<mat-sidenav-container>
  <mat-sidenav-content>

    <form [formGroup]="credentialsForm" id="container">
      @if (!mobile) {
        <mat-card appearance="outlined" class="mat-elevation-z8">
          <div [hidden]="!imageLoaded" class="center">
            @if (!check) {
              <div class="d-none d-lg-block col-12 col-lg-7 col-xl-8">
                <img >
              </div>
            }
            <div class="col-12 col-lg-5 col-xl-4">
              <div id="container-login">
                <mat-card-title>
                </mat-card-title>
                <mat-divider class="d-lg-none" inset></mat-divider>
                <mat-card-title>
                  <h3>{{systemName}}</h3>
                </mat-card-title>
                <mat-card-content>
                  <mat-form-field floatLabel="always">
                    <mat-label>Nombre de usuario</mat-label>
                    <input matInput name="username" [placeholder]="check?'RFC':'NO. CONTROL - RFC'"
                      formControlName="username" [disabled]="onLogin">
                  </mat-form-field>
                  <mat-form-field floatLabel="always">
                    <mat-label>Contraseña</mat-label>
                    <input matInput name="password" [disabled]="onLogin" placeholder="CONTRASEÑA"
                      [type]="hide ? 'password' : 'text'" (keydown.enter)="$event.preventDefault()"
                      (keydown.shift.enter)="$event.preventDefault()" (keydown.enter)="login()"
                      (keydown.shift.enter)="login()" formControlName="password">
                    <button type="button" [disabled]="onLogin" mat-icon-button matSuffix
                      (click)="hide = !hide">
                      <mat-icon color="primary">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                  </mat-form-field>
                  @if (error) {
                    <h4 class="error">{{ errorMessage }}</h4>
                    @if (showCaptcha) {
                      <p class="text-center">Para confirmar que eres una persona y no un robot,
                      resuelve el reCAPTCHA.</p>
                      <div class="help-actions text-center">
                        <re-captcha [theme]="darkMode?'dark':'light'" #captcha [siteKey]="siteKey"
                        (resolved)="resolved($event)" errorMode="handled"></re-captcha>
                      </div>
                    }
                  }
                  @if (!showCaptcha && !check) {
                    <mat-card-actions>
                      <div class="row">
                        @if (aspirantes) {
                          <div class="col-12 mb-2">
                            <a class="link" (click)="openDialogNuevoAspirante()">Eres Aspirante Nuevo y
                              No te has
                            Registrado</a>
                            <hr>
                            </div>
                          }
                          @if (aspirantesPosgrado) {
                            <div class="col-12 mb-2">-->
                              <!-- <a class="link" (click)="openDialogNuevoAspirante(true)">Eres Aspirante
                              Nuevo a
                              Maestría y No te has
                            Registrado</a> -->
                            <a class="link" (click)="openDialogNuevoAspirante(true)">Registrate Aquí
                              para
                            Maestría</a>
                            <hr>
                            </div>
                          }
                          <div class="col-12">
                            <a class="link" (click)="openDialog()">¿No puedes Acceder a tu Cuenta?</a>
                          </div>
                        </div>
                      </mat-card-actions>
                    }
                    <mat-card-actions>
                      <button mat-raised-button color="primary" type="submit" (click)="login()"
                        [disabled]="onLogin || !credentialsForm.valid">
                        <span>Acceso</span>
                      </button>
                    </mat-card-actions>
                  </mat-card-content>
                </div>
              </div>
            </div>
          </mat-card>
        } @else {
          @if (mobile) {
            <div class="padding">
              <img>
              <br>
                <br>
                  <h3>{{systemName}}</h3>
                  <br>
                    <mat-form-field floatLabel="always">
                      <mat-label>Nombre de usuario</mat-label>
                      <input matInput name="username" [placeholder]="check?'RFC':'NO. CONTROL - RFC'"
                        [disabled]="onLogin" formControlName="username">
                    </mat-form-field>
                    <mat-form-field floatLabel="always">
                      <mat-label>Contraseña</mat-label>
                      <input matInput [disabled]="onLogin" name="password" placeholder="CONTRASEÑA"
                        [type]="hide ? 'password' : 'text'" formControlName="password"
                        (keydown.enter)="$event.preventDefault()" (keydown.shift.enter)="$event.preventDefault()"
                        (keydown.enter)="login()" (keydown.shift.enter)="login()">
                      <button type="button" [disabled]="onLogin" mat-icon-button matSuffix (click)="hide = !hide">
                        <mat-icon color="primary">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                      </button>
                    </mat-form-field>
                    @if (error) {
                      <h4 class="error">{{ errorMessage }}</h4>
                      @if (showCaptcha) {
                        <p class="text-center">Para confirmar que eres una persona y no un robot,
                        resuelve el reCAPTCHA.</p>
                        <div class="help-actions text-center">
                          <re-captcha [theme]="darkMode?'dark':'light'" #captcha [siteKey]="siteKey"
                          (resolved)="resolved($event)" errorMode="handled"></re-captcha>
                        </div>
                      }
                    }
                    @if (!showCaptcha) {
                      <br>
                      }
                      @if (!showCaptcha) {
                        <br>
                        }
                        @if (!showCaptcha && !check) {
                          <div class="row">
                            @if (aspirantes) {
                              <div class="col-12 mb-2">
                                <a class="link" (click)="openDialogNuevoAspirante()">Eres Aspirante Nuevo y No te has
                                Registrado</a>
                                <hr>
                                </div>
                              }
                              @if (aspirantesPosgrado) {
                                <div class="col-12 mb-2">
                                  <!-- <a class="link" (click)="openDialogNuevoAspirante(true)">Eres Aspirante Nuevo a
                                  Maestría y No te has
                                Registrado</a> -->
                                <a class="link" (click)="openDialogNuevoAspirante(true)">Registrate Aquí para
                                Maestría</a>
                                <hr>
                                </div>
                              }
                              <div class="col-12">
                                <a class="link" (click)="openDialog()">¿No puedes Acceder a tu Cuenta?</a>
                              </div>
                            </div>
                          }
                          @if (!showCaptcha) {
                            <br>
                            }
                            @if (!showCaptcha) {
                              <br>
                              }
                              <button mat-raised-button color="primary" type="submit" (click)="login()"
                                [disabled]="onLogin || !credentialsForm.valid">
                                <span>Acceso</span>
                              </button>
                            </div>
                          }
                        }
                      </form>

                    </mat-sidenav-content>
                  </mat-sidenav-container>
